import { ApiStatus } from '../../types';

export interface EmploymentApiData {
    employmentId?: string,
    recordVersion?: string,
    employmentCategory: string,
    employmentFrequency: string,
    positionTitle: string,
    profession: string,
    startDate: string,
    endDate?: string,
    isPrimaryEmployment: boolean,
    employer?: Employer,
}

export interface EmploymentDetails extends EmploymentApiData, EmploymentUpsertApiResponse {
    recordNumber?: number;
    isEditMode?: boolean;
}

export interface EmploymentUpsertApiResponse {
    success?: boolean,
    reason?: Record<string, string>,
    result?: string,
    employment?: EmploymentDetails,
    employments?: Record<number, EmploymentDetails>
}

export interface Employer {
    name?: string,
}

export interface EmploymentsErrorMessage {
    employmentStatus?: string;
    employerName?: string;
    positionTitle?: string;
    profession?: string;
    startDate?: string;
    endDate?: string;
}

export const employmentsAEM = {
    'heading': '{Heading placeHolder}',
    'description': '{description placeholder}',
    'newDescription': '{newDescription placeholder}',
    'addButtonText': '{addButtonText}',
    'addButton': '{addButton}',
    'submitButton': 'Next',
    'cardHeaderMainEmploymentText': '/ Main Employment',
    'endDateNow': 'now',
    'editButtonText': '{editButtonText}',
    'editPanelHeading': '{editPanelHeading placeholder}',
    'mainEmployment': '/ {mainEmployment placeholder}',
    'employerNameSuffix': 'Staff',
    'selfEmployedNameSuffix': '(Self employed)',
    'currentEmploymentLabel': '{currentEmployment placeholder}',
    'cancelButtonText': '{cancelButtonText placeholder}',
    'updateButtonText': '{updateButtonText placeholder}',
    'addEmployments': {
        'heading': '{add employment heading text placeholder}',
        'cancelButtonText': '{cancelButtonText placeholder}',
        'addButtonText': '{addButtonText placeholder}',
        'businessNameLabel': '{businessName placeholder}',
        'employedCategoryLabel': '{employedCategoryLabel placeholder}',
        'unemployedCategoryLabel': '{unemployedCategoryLabel placeholder}',
        'occupationLabel': '{occupation placeholder}',
        'startDateLabel': '{startDateLabel placeholder}',
        'endDateLabel': '{endDateLabel placeholder}',
        'employmentStatusLabel': '{employmentStatus Placeholder}',
        'mainEmploymentCheckbox': '{mainEmploymentCheckboxLabel placeholder}',
        'currentlyEmployedCheckbox': '{currentlyEmployedCheckboxLabel placeholder}',
        'currentlyUnemployedCheckbox': '{currentlyUnemployedCheckboxLabel placeholder}',
    },
    'employed': {
        'employmentCategoryName': '{employmentCategoryName placeholder}',
        'nameLabel': '{employed nameLabel placeholder}',
        'startDateLabel': '{StartDateLabel placeholder}',
        'endDateLabel': '{endDateLabel placeholder}',
    },
    'unemployed': {
        'employmentCategoryName': 'Not Employed',
        'occupationLabel': 'Type of unemployment',
        'startDateLabel': 'Start date',
        'endDateLabel': 'End date',
        'currentEmploymentLabel': 'I\'m still not employed',
        'addButtonLabel': 'add',
        'cancelButtonLabel': 'cancel',
    },
    'employmentStatusCategories': [
        {
            'key': 'Employed - Full time',
            'value': 'Employed All Other',
        },
        {
            'key': 'Employed - Part time',
            'value': 'Employed All Other',
        },
        {
            'key': 'Employed - Casual/Temp',
            'value': 'Employed All Other',
        },
        {
            'key': 'Employed - Seasonal',
            'value': 'Employed All Other',
        },
        {
            'key': 'Self-Employed',
            'value': 'Employer or Self-Employed',
        },
        {
            'key': 'Not Employed',
            'value': 'Not Employed',
        },
    ],
    'employmentStatusFrequencies': [
        {
            'key': 'Employed - Full time',
            'value': 'Full Time',
        },
        {
            'key': 'Employed - Part time',
            'value': 'Part Time',
        },
        {
            'key': 'Employed - Casual/Temp',
            'value': 'Temporary',
        },
        {
            'key': 'Employed - Seasonal',
            'value': 'Seasonal',
        },
        {
            'key': 'Self-Employed',
            'value': 'Undefined',
        },
        {
            'key': 'Not Employed',
            'value': 'Undefined',
        },
    ],
    'unemployedProfessions': [
        {
            'key': 'Home Duties',
            'value': '36',
        },
        {
            'key': 'Student',
            'value': '96',
        },
        {
            'key': 'Disability Support Pension',
            'value': '39',
        },
        {
            'key': 'Retired',
            'value': '60',
        },
        {
            'key': 'Other',
            'value': '65',
        },
    ],
};

export const employmentValidationsAEM = {
    'employmentStatusRequired': 'Select employment status',
    'employerNameRequired': 'Enter Business Name',
    'maxLength': '80',
    'maxLengthMessage': 'You can only enter maximum of 80 characters',
    'employmentCategoryRequired': 'Select employment category',
    'occupationRequired': 'Select occupation',
    'startDateRequired': 'Enter start date',
    'startDateInvalid': 'Start date is invalid',
    'startDateMax': 'Date needs to be in the past',
    'endDateRequired': 'Enter end date',
    'endDateInvalid': 'End date is invalid',
    'endDateMin': 'Date needs to be greater than start date',
    'endDateMax': 'End date cannot be greater than today’s date',
    'patternName': 'Enter letters, spaces and numbers only',
    'patternDate': 'Date’s format should be DD/MM/YYYY',
    'endDateNotAllowedInCurrent': 'Previous employment cannot be set as main employment',
    'noMainEmployment': 'You need to select one status as your main employment. Main employment is where you earn the most income.',
    'employedAndUnemployed': 'You’ve selected work status employed and not employment over the same time period. Confirm your current details by adjusting your dates or work status.',
    'employmentLength': 'Tell us about your previous work status.',
    'startDateAndEndDate': '{0} cannot be lower than {1}',
    'duplicatePreviousEmployer': '<b>You will need to add your previous employer</b> /n Looks like you have only been at your current employer for two months or less. /n Please provide the details of your previous employer as well.',
    'duplicateMainEmploymentHeading': 'You can only choose one main employer',
    'duplicateMainEmploymentDescription': 'Make sure you update your main employer if it is not correct. /n Keep in mind, main employment is where you earn the most income.',
    'unemploymentCategoryMissing': 'Select unemployment category',
};

export const defaultEmploymentsAEM = {
    ...employmentsAEM,
    validations: employmentValidationsAEM,
};

export type EmploymentsAEM = typeof defaultEmploymentsAEM;
export type EmploymentValidationsAEM = typeof employmentValidationsAEM;

export interface EmploymentsEndpoints {
    getEmploymentsUrl: string,
    getRefDataUrl: string,
    addUrl: string,
    updateUrl: string,
    validateUrl: string,
    submitUrl?: string
}

export interface ValidationResponse {
    result: boolean
    validationMessageHeading: string
    validationMessageDescription: string
    showConfirmation: boolean
    confirmationMessage: string
}

export interface RefDataDropdownOptions {
    id: string
    description: string
}

export interface EmploymentsCategory extends RefDataDropdownOptions {
    display: boolean;
}

export interface EmploymentProfessions extends RefDataDropdownOptions {
    categoryId: number
}

export interface EmploymentsRefData {
    employmentCategories: Record<number, EmploymentsCategory>
    employmentFrequencies: Record<number, RefDataDropdownOptions>
    professionCategories: Record<number, RefDataDropdownOptions>
    professions: Record<number, EmploymentProfessions>
    minimumEmployedMonths: number
    minimumSelfEmployedMonths: number
    content: string
}

export interface EmploymentsState {
    content: EmploymentsAEM
    apiEndpoints: EmploymentsEndpoints
    employments: Record<number, EmploymentDetails>
    refData: EmploymentsRefData
    validationResponse: ValidationResponse
    getEmploymentsApiStatus: ApiStatus
    getRefDataApiStatus: ApiStatus
    addEmploymentApiStatus: ApiStatus
    updateEmploymentApiStatus: ApiStatus
    validateApiStatus: ApiStatus
    submitApiStatus: ApiStatus
    isAddMode: boolean
    lastVisitedItem: {
        employerId?: string
        id: number | null
        mode: 'add' | 'edit' | null
        isSaved: boolean
    }
}
